import { Grid, Avatar, Typography } from '@mui/material';
import useStyles from './style';
import './style.css';

import {
  ArrowUpward as ArrowUpwardIcon,
  AttachMoney,
  ShoppingCart,
  Restaurant,
  PeopleAlt,
} from '@mui/icons-material';
import { primaryColor } from '../../../../constants/colors';
import FavoriteIcon from '@mui/icons-material/Favorite';
import AccessibilityNewIcon from '@mui/icons-material/AccessibilityNew';
import GroupsIcon from '@mui/icons-material/Groups';

const Cards = ({ dashboardData }) => {
  console.log(dashboardData, "dashboardDatadashboardDatadashboardData")
  const classes = useStyles();

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} sm={12} md={12}>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6} md={4}>
            <div
              className={`${classes.customCard} card-style`}
              style={{ backgroundColor: 'rgb(30, 136, 229)' }}
            >
              <div className='container-two'>
                <Grid
                  container
                  className='avatar-container avatar-container-two'
                >
                  <Grid item>
                    <Avatar className='avatar-style'>
                      <FavoriteIcon />
                    </Avatar>
                  </Grid>
                </Grid>
              </div>
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <Typography className={classes.count}>
                  {dashboardData?.totalLikes ? dashboardData.totalLikes : 0}
                </Typography>
                <Avatar className={classes.avatarStyle}>
                  <ArrowUpwardIcon
                    fontSize='inherit'
                    style={{ transform: 'rotate3d(1, 1, 1, 45deg)' }}
                  />
                </Avatar>
              </div>
              <div>
                <p
                  className={classes.title}
                  style={{ color: 'rgb(144, 202, 249)' }}
                >
                  Total Likes
                </p>
              </div>
            </div>
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <div
              className={`${classes.customCard} card-style`}
              style={{ backgroundColor: '#BD4291' }}
            >
              <div className='main-users'>
                <Grid className='avatar-container product-container'>
                  <Grid item>
                    <Avatar className='avatar-style'>
                      <AccessibilityNewIcon />
                    </Avatar>
                  </Grid>
                </Grid>
              </div>
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <Typography
                  className={classes.count}
                  style={{ color: 'white' }}
                >
                  {dashboardData?.totalMatches ? dashboardData.totalMatches : 0}
                </Typography>
                <Avatar
                  className={classes.avatarStyle}
                  style={{ backgroundColor: '#fff8e1' }}
                >
                  <ArrowUpwardIcon
                    fontSize='inherit'
                    style={{
                      transform: 'rotate3d(1, 1, 1, 45deg)',
                      color: '#fff',
                    }}
                  />
                </Avatar>
              </div>
              <div>
                <p
                  className={classes.title}
                  style={{ color: 'rgb(144, 202, 249)' }}
                >
                  Total Matches
                </p>
              </div>
            </div>
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <div
              className={`${classes.customCard} card-style`}
              style={{ backgroundColor: '#bd4242' }}
            >
              <div className='main-users'>
                <Grid className='avatar-container product-container'>
                  <Grid item>
                    <Avatar className='avatar-style'>
                      <GroupsIcon />
                    </Avatar>
                  </Grid>
                </Grid>
              </div>
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <Typography
                  className={classes.count}
                  style={{ color: 'white' }}
                >
                  {dashboardData?.totalUsers ? dashboardData.totalUsers : 0}
                </Typography>
                <Avatar
                  className={classes.avatarStyle}
                  style={{ backgroundColor: '#fff8e1' }}
                >
                  <ArrowUpwardIcon
                    fontSize='inherit'
                    style={{
                      transform: 'rotate3d(1, 1, 1, 45deg)',
                      color: '#fff',
                    }}
                  />
                </Avatar>
              </div>
              <div>
                <p
                  className={classes.title}
                  style={{ color: 'rgb(144, 202, 249)' }}
                >
                  Total Users
                </p>
              </div>
            </div>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default Cards;
